export const getTextFromHtml = (html: string) => {
  const divContainer = document.createElement("div");
  divContainer.innerHTML = html;

  const text = divContainer.textContent || divContainer.innerText;

  return text?.trim() || "";
};
